import DateEditor from './DateEditor';
import PercentageEditor from './PercentageEditor';
import ColorEditor from './ColorEditor';
import TextAreaEditor from './TextAreaEditor';
import MultiSelectEditor from './MultiSelectEditor';

export default { PercentageEditor, DateEditor, ColorEditor, TextAreaEditor, MultiSelectEditor };


// WEBPACK FOOTER //
// ./src/editors/index.js